import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import MendIOConfigListing from './MendIOConfigListing'
import MendIOCredentialsForm from './MendIOCredentialsForm'

export default function MendIOPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={MendIOCredentialsForm}
            PullConfigListingView={MendIOConfigListing}
        />
    )
}